import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/projects/$projectSlug/templates/")({
  beforeLoad: () => {
    throw redirect({
      from: "/projects/$projectSlug/templates/",
      to: "/projects/$projectSlug",
    });
  },
});
